import React from 'react';
// Icons
import { FaBluesky } from 'react-icons/fa6';
import { FaTwitter } from 'react-icons/fa';
// Constants
import {
  BLUESKY_URL,
  CLIPS4SALE_URL,
  FETLIFE_URL,
  I_WANT_CLIPS_URL,
  LOYALFANS_URL,
  MANY_VIDS_URL,
  TWITTER_URL,
} from '../../utils/constants/Constants';
// Imagess
import LoyalFansIcon from '../../assets/images/icons/loyalfans-icon-no-background.png';
import ManyVidsIcon from '../../assets/images/icons/manyvids-icon.png';
import C4SIcon from '../../assets/images/icons/clips-4-sale-logo-purple.png';
import FetlifeIcon from '../../assets/images/icons/fetfile-icon-no-background.png';

export const smallFanSitesArray = [
  {
    name: 'LoyalFans',
    url: LOYALFANS_URL,
    logo: LoyalFansIcon,
    description:
      'Premium fetish content with direct interaction and exclusive perks.',
  },
];

export const fanSitesArray = [
  {
    name: 'LoyalFans',
    url: LOYALFANS_URL,
    logo: LoyalFansIcon,
    description:
      'Premium fetish content with direct interaction and exclusive perks.',
  },
  {
    name: 'I Want Clips',
    url: I_WANT_CLIPS_URL,
    icon: <div>IWC</div>,
    description:
      'Premium fetish content with direct interaction and exclusive perks.',
  },
  {
    name: 'Clips 4 Sale',
    url: CLIPS4SALE_URL,
    icon: C4SIcon,
    description:
      'Premium fetish content with direct interaction and exclusive perks.',
  },
  {
    name: 'ManyVids',
    url: MANY_VIDS_URL,
    logo: ManyVidsIcon,
    description:
      'Premium fetish content with direct interaction and exclusive perks.',
  },
  {
    name: 'Twitter',
    icon: <FaTwitter className='text-6xl' />,
    url: TWITTER_URL,
    description: 'Follow to Me and see My exclusive links.',
  },
];

export const socialMediaBigPinArray = [
  {
    name: 'LoyalFans',
    url: LOYALFANS_URL,
    icon: LoyalFansIcon,
    description: 'Stay updated on new content and links.',
  },
  {
    name: 'Fetlife',
    url: FETLIFE_URL,
    icon: FetlifeIcon,
    description: 'Stay updated on new content and links.',
  },
  {
    name: 'Twitter',
    url: TWITTER_URL,
    icon: <FaTwitter className='text-6xl' />,
    description: 'Stay updated on new content and links.',
  },
  {
    name: 'BlueSky',
    url: BLUESKY_URL,
    icon: <FaBluesky className='text-6xl' />,
    description: 'Stay updated on new content and links.',
  },
];
